import View from './view';
import React, {useEffect} from 'react';
import {useModifiedRouterParams} from '../../../../shared/hooks/routeParams';
import {useModal} from '../../../../shared/components/modal';
import {CreateRequestDesktop} from '../createRequest/desktop';
import {IOwnProps} from './model';
import {Screens} from '../../../../shared/routing';
import {useIsDesktop} from '../../../../shared/hooks/useIsDesktop';
import {useSelector, useDispatch} from 'react-redux';
import {profileRequestsSelector} from '../../../../redux/selectors/profile';
import {usePartialList} from '../../../../shared/hooks/usePartialList';
import {RequestResponsePayload} from '../../../../shared/models/api';
import {getProfileRequests} from '../../../../redux/actions/profile';
import {SupportServiceTopic} from '../topic';
import {Platform} from 'react-native';
import {defaults} from '../../../../shared/constants/defaults';

export const SupportServiceTopics: React.FC<IOwnProps> = ({navigation}) => {
  const modal = useModal();
  const dispatch = useDispatch();
  const isDesktop = useIsDesktop();
  const requests = useSelector(profileRequestsSelector()) as RequestResponsePayload[];
  const [itemsToShow, showMore, allShown] = usePartialList(
    requests,
    Platform.OS === 'web' ? defaults.partialListSizeWithButton : defaults.partialListSizeWithScroll,
  );

  useEffect(() => {
    if (!requests) {
      dispatch(getProfileRequests());
    }
  }, [requests]);

  useModifiedRouterParams<{id: string}>((params) => {
    if (params.id) {
      if (params.id === 'new') {
        modal.show({
          render({id: modalId}, methods) {
            const handleClose = () => {
              methods.remove(modalId);
              navigation.navigate(Screens.SupportServiceTopics, {id: ''});
              dispatch(getProfileRequests());
            };

            return React.createElement(CreateRequestDesktop, {
              onModalClose: handleClose,
            });
          },
        });

        return;
      }
      modal.show({
        render({id: modalId}, methods) {
          const handleClose = () => {
            methods.remove(modalId);
            navigation.navigate(Screens.SupportServiceTopics, {id: ''});
          };

          return React.createElement(SupportServiceTopic, {
            onModalClose: handleClose,
            route: {params: {id: +params.id}},
          });
        },
      });
    }
  });

  return React.createElement(View, {
    showMore,
    allShown,
    requests: itemsToShow,
    onPressTopicCreate() {
      if (isDesktop) {
        navigation.navigate(Screens.SupportServiceTopics, {id: 'new'});
      } else {
        navigation.navigate(Screens.SupportServiceCreateTopic);
      }
    },
  });
};
